import { Key, useEffect, useState } from "react";
import IconComponent from "./Icon";
import { FaAngleDown, FaBook, FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";

const QuoteCard = () => {
    const [quote, setQuote] = useState({
        content: '',
        author: '',
        quote: '',
        book: '',
    });
    const [loading, setLoading] = useState(false);
    
    const getQuote = async () => {
        try {
            setLoading(true);
            const response = await fetch('https://api.api-ninjas.com/v1/quotes', {
                headers: {
                    'X-Api-Key': 'Zx/D6GPfd7KHmcs5eDt+Kg==sawE7DhH3ea9jVrQ',
            }});
            const data = await response.json();
            setQuote(data[0]);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching bestsellers:', error);
        }
    };

    useEffect(() => {
        getQuote();
    }, []);

    return (
        <div className="bg-[#60637A] rounded-3xl shadow-lg p-4 min-h-20 mt-[40px]">
        <div className="flex flex-col h-full">
          <h1 className="text-2xl font-bold mb-0 text-white">
            Random Quote
          </h1>
          <p className="text-white">{quote.quote}</p>
          <p className="text-white italic pt-2">{quote.author}</p>
        </div>
      </div>
    );
};export default QuoteCard;